import React from 'react';
import LanguageComponent from 'src/components/language-selector/language.component';
import 'url-search-params-polyfill';
// styles
const styles = require('./credentials.scss');

interface IState {
  bookingNotFound: boolean;
  bookingReference: string;
  emailAddress: string;
  bookingReferenceEmpty: boolean;
  emailAddressEmpty: boolean;
  emailAddressIncorrect: boolean;
}

interface IProps {
  bookingNotFound: boolean;
  language: string;
  languageCode: string;
  multiLang: any;
  handleLanguageChange: any;
  handleLogin(event: any): void;
}

class CredentialsComponent extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      bookingNotFound: props.bookingNotFound,
      bookingReference: '',
      emailAddress: '',
      bookingReferenceEmpty: false,
      emailAddressEmpty: false,
      emailAddressIncorrect: false
    };
  }

  componentDidMount() {
    window.history.pushState({}, document.title, '/');
  }

  componentWillReceiveProps(props: IProps) {
    this.setState({ bookingNotFound: props.bookingNotFound });
  }

  handleReferenceChange(event) {
    this.setState({ bookingReference: event.target.value });
  }

  handleEmailChange(event) {
    this.setState({ emailAddress: event.target.value });
  }

  handleValidation() {
    const emailPatternError = !this.state.emailAddress.match(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/);
    let isValid = true;

    if (this.state.bookingReference === '') {
      this.setState({ bookingReferenceEmpty: true });
      isValid = false;
    } else {
      this.setState({ bookingReferenceEmpty: false });
    }

    if (this.state.emailAddress === '') {
      this.setState({ emailAddressEmpty: true });
      isValid = false;
    } else {
      this.setState({ emailAddressEmpty: false });
    }

    if (emailPatternError) {
      this.setState({ emailAddressIncorrect: true });
      isValid = false;
    } else {
      this.setState({ emailAddressIncorrect: false });
    }

    return isValid;
  }

  handleSubmit(event) {
    event.preventDefault();

    const isValid = this.handleValidation();

    if (isValid) {
      this.props.handleLogin(this.state);
    }
  }

  render() {
    const { language, multiLang, languageCode, handleLanguageChange } = this.props;

    return (
      <div className={styles.mainContent}>
        <LanguageComponent selectedLanguage={languageCode}
          handleLanguageChange={handleLanguageChange} />

        <div className={styles.section}>
          {this.state.bookingNotFound
            ? <div className={styles.errorMessageBox}>
              <p>{multiLang[`errorMessageNoBookingFound${language}`]}</p>
            </div>
            : null
          }
          <div className={styles.card}>
            <form className={styles.cardBody} onSubmit={this.handleSubmit.bind(this)} noValidate>

              <div className={styles.formControl}>
                <label className={styles.controlLabel} htmlFor='bookingReference'>
                  {multiLang[`bookingReference${language}`]}
                </label>
                <input
                  type='text'
                  id='bookingReference'
                  name='bookingReference'
                  autoComplete='off'
                  value={this.state.bookingReference}
                  onChange={this.handleReferenceChange.bind(this)} />

                {this.state.bookingReferenceEmpty
                  ? <div className={styles.errorMessage}>
                    <p>{multiLang[`errorTextBookingReferenceInvalid${language}`]}</p>
                  </div>
                  : null
                }
              </div>

              <div className={styles.formControl}>
                <label className={styles.controlLabel} htmlFor='emailAddress'>
                  {multiLang[`emailAddressLabel${language}`]}
                </label>
                <input
                  type='email'
                  id='emailAddress'
                  name='emailAddress'
                  autoComplete='off'
                  value={this.state.emailAddress}
                  onChange={this.handleEmailChange.bind(this)} />

                {this.state.emailAddressEmpty
                  ? <div className={styles.errorMessage}>
                    <p>{multiLang[`errorTextEmailAddressRequired${language}`]}</p>
                  </div>
                  : this.state.emailAddressIncorrect
                    ? <div className={styles.errorMessage}>
                      <p>{multiLang[`errorTextEmailAddressInvalid${language}`]}</p>
                    </div>
                    : null
                }
              </div>

              <button
                className={styles.btnPrimary}
                type='submit'
                id='submitForm'>
                {multiLang[`trackBookingButton${language}`]}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

}

export default CredentialsComponent;



// WEBPACK FOOTER //
// ./src/containers/credentials/credentials.component.tsx